// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AccordionSection, { AccordionSectionProps } from "@insite/mobius/AccordionSection/AccordionSection";
import omitMultiple from "@insite/mobius/utilities/omitMultiple";
import React from "react";

type State = Pick<AccordionSectionProps, "expanded"> & { initialExpandedPrevProps?: boolean };

/**
 * An accordion section that manages itself, allowing the user to set an initial expanded state and governing expanded
 * and contracted states from there.
 */
class ManagedAccordionSection extends React.Component<AccordionSectionProps & { initialExpanded?: boolean }, State> {
    state = { expanded: this.props.initialExpanded, initialExpandedPrevProps: this.props.initialExpanded };

    // <XNG-Changes> allow to update initialExpanded props
    static getDerivedStateFromProps(
        nextProps: AccordionSectionProps & { initialExpanded?: boolean },
        prevState: State,
    ) {
        if (prevState.initialExpandedPrevProps !== nextProps.initialExpanded) {
            return {
                expanded: nextProps.initialExpanded,
                initialExpandedPrevProps: nextProps.initialExpanded,
            };
        }
        // Return null to indicate no change to state.
        return null;
    }
    // </XNG-Changes>

    componentDidUpdate(
        prevProps: Readonly<AccordionSectionProps & { initialExpanded?: boolean }>,
        prevState: Readonly<State>,
        snapshot?: any,
    ) {
        if (prevProps.initialExpanded !== this.props.initialExpanded) {
            // this.setState({
            //     expanded: this.props.initialExpanded,
            // });
        }
    }

    toggle = () => {
        this.setState(
            ({ expanded }) => {
                return { expanded: !expanded };
            },
            () => {
                if (this.props.onTogglePanel) {
                    this.props.onTogglePanel(this.state.expanded ?? false);
                }
            },
        );
    };

    render() {
        return (
            <AccordionSection
                {...omitMultiple(this.props, ["onTogglePanel", "expanded"])}
                expanded={this.state.expanded}
                onTogglePanel={this.toggle}
            />
        );
    }
}

export default ManagedAccordionSection;
